"use strict";

exports.__esModule = true;
exports.GlobalStyles = void 0;
var _styledComponents = require("styled-components");
var _utils = require("./utils");
// Packages

const {
  above
} = (0, _utils.getMediaQueries)();
const GlobalStyles = (0, _styledComponents.createGlobalStyle)([".main-container{margin-left:auto;margin-right:auto;max-width:100%;width:1152px;p{margin:0;}}.padding-container{padding:64px 24px;.title{font-family:Source Sans Pro;}", " ", "}"], above.mobile`
      padding: 96px 48px;
    `, above.tablet`
      padding-bottom: 120px;
      padding-top: 120px;
    `);
exports.GlobalStyles = GlobalStyles;